import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fc726c88&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=fc726c88&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=fc726c88&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc726c88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc726c88')) {
      api.createRecord('fc726c88', component.options)
    } else {
      api.reload('fc726c88', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=fc726c88&scoped=true", function () {
      api.rerender('fc726c88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ik/form/input/IkFormDataPopup/index.vue"
export default component.exports